import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { seoConfig } from "../lib/SeoConfig";

const SeoHelmet = () => {
  const location = useLocation();
  const currentPath = location.pathname.replace(/\/+$/, "") || "/";
  const siteUrl = "https://www.partslokator.com";
  const canonicalUrl = `${siteUrl}${currentPath}`;
  const ogImage = `${siteUrl}/og-preview.jpg`;

  const sortedConfig = [...seoConfig].sort(
    (a, b) => b.path.length - a.path.length,
  );

  const matchedSeo =
    sortedConfig.find(
      (item) =>
        item.path !== "*" &&
        item.path !== "/:slug" &&
        (currentPath === item.path ||
          (item.path !== "/" && currentPath.startsWith(item.path + "/"))),
    ) || sortedConfig.find((item) => item.path === currentPath);

  const { vendorCompany } = useSelector((state) => state.parts);

  // Check if current path is a likely vendor slug (1 segment detailed check)
  // Logic: It's 1 segment deep (e.g. /foo), not in config, and not reserved.
  const pathSegments = currentPath.split("/").filter(Boolean);
  const isVendorProfile =
    pathSegments.length === 1 &&
    !matchedSeo &&
    !["dashboard", "profile", "login", "register", "admin"].includes(
      pathSegments[0],
    );

  const vendorConfig = seoConfig.find((item) => item.path === "/:slug");
  const fallbackSeo = seoConfig.find((item) => item.path === "*");

  let seo = matchedSeo;

  if (isVendorProfile && vendorConfig) {
    seo = {
      ...vendorConfig,
      title: vendorCompany?.companyName
        ? `${vendorCompany.companyName} | PartsLokator`
        : vendorConfig.title,
    };
  }

  if (!seo) {
    seo = fallbackSeo;
  }

  const robots = seo?.robots || "index, follow";

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />

      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PartsLokator" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@PartsLokator" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="robots" content={robots} />
    </Helmet>
  );
};

export default SeoHelmet;
